import { useStudyContext } from '../../../common/context/study/useStudyContext';

type Out = {
  isContainerSyncEnabled: boolean;
};

export const useContainerSync = (): Out => {
  const { studyConfig } = useStudyContext();

  return {
    isContainerSyncEnabled: studyConfig.hbsConfig.isContainerSyncEnabled,
  };
};
